import type { SyntheticEvent } from 'react'
import type { CounterVariant } from '@/tools/ui'
import {
  Counter,
  CounterSize,
  IconButton,
  IconButtonSize,
  MinusIcon,
  PlusIcon,
  TrashIcon,
} from '@/tools/ui'

export interface ProductCounterProps {
  value: number
  variant: CounterVariant
  disabled?: boolean
  onAdd: (e?: SyntheticEvent<HTMLButtonElement>) => void
  onRemove: (e?: SyntheticEvent<HTMLButtonElement>) => void
}

export const ProductCounter: React.FC<ProductCounterProps> = ({
  value,
  variant,
  disabled,
  onAdd,
  onRemove,
}) => {
  const isProductInCart = value > 0
  const isSingleProductInCart = value === 1

  const handleOnRemove = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onRemove(e)
  }

  const handleOnAdd = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onAdd(e)
  }

  const leadingIconButton = isProductInCart ? (
    <IconButton
      aria-label={isSingleProductInCart ? 'Remove item' : 'Decrease quantity'}
      icon={isSingleProductInCart ? TrashIcon : MinusIcon}
      size={IconButtonSize.xxsmall}
      onClick={handleOnRemove}
    />
  ) : undefined

  return (
    <Counter
      disabled={disabled}
      leadingIconButton={leadingIconButton}
      quantity={isProductInCart ? String(value) : undefined}
      size={CounterSize.small}
      trailingIconButton={
        <IconButton
          aria-label="Increase quantity"
          icon={PlusIcon}
          size={IconButtonSize.xxsmall}
          onClick={handleOnAdd}
        />
      }
      variant={variant}
    />
  )
}
